import React, { useState, useRef } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';

const ContactForm = () => {

    const formRef = useRef();
    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    
    const [validator] = useState(
      new SimpleReactValidator({
        className: "errorMessage",
        messages: {
          required: "Este campo es requerido",
        }
      })
    );
    
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        
        if (!validator.allValid()) {
            validator.showMessages();
            return;
        }

        setIsLoading(true);
        validator.hideMessages();

        try {
            // Configura estos valores con tus credenciales de EmailJS
            // Puedes obtenerlos desde https://www.emailjs.com/
            const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
            const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
            const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

            // Validar que las credenciales estén configuradas
            if (!serviceID || !templateID || !publicKey || 
                serviceID === 'YOUR_SERVICE_ID' || 
                templateID === 'YOUR_TEMPLATE_ID' || 
                publicKey === 'YOUR_PUBLIC_KEY') {
                toast.error('Error: Las credenciales de EmailJS no están configuradas. Por favor, configura las variables de entorno.');
                console.error('EmailJS no configurado. Variables requeridas:', {
                    serviceID: serviceID ? '✓' : '✗',
                    templateID: templateID ? '✓' : '✗',
                    publicKey: publicKey ? '✓' : '✗'
                });
                setIsLoading(false);
                return;
            }

            // Enviar el email usando EmailJS
            // El remitente siempre será developerwmclinicplus@gmail.com
            // El email del usuario se incluye como reply_to para poder responderle
            // Nota: Los nombres de las variables deben coincidir con los nombres en tu plantilla de EmailJS
            const result = await emailjs.send(
                serviceID,
                templateID,
                {
                    to_email: 'developerwmclinicplus@gmail.com', // Email destinatario (donde recibes los mensajes)
                    user_name: forms.name,
                    from_email: 'developerwmclinicplus@gmail.com', // Email remitente fijo
                    user_email: forms.email, // Email del usuario para responder
                    phone: forms.phone,
                    subject: forms.subject || 'Sin asunto',
                    message: forms.message,
                },
                publicKey
            );

            console.log('Email enviado exitosamente:', result);

            toast.success('¡Mensaje enviado exitosamente!');
            
            // Limpiar el formulario
            setForms({
                name: '',
                email: '',
                subject: '',
                phone: '',
                message: ''
            });
            
        } catch (error) {
            console.error('Error detallado al enviar el email:', error);
            
            // Mensajes de error más específicos
            let errorMessage = 'Error al enviar el mensaje. Por favor, inténtalo de nuevo.';
            
            if (error.text) {
                errorMessage = `Error: ${error.text}`;
            } else if (error.message) {
                errorMessage = `Error: ${error.message}`;
            } else if (typeof error === 'string') {
                errorMessage = `Error: ${error}`;
            }
            
            toast.error(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    return (
      <form
        ref={formRef}
        onSubmit={(e) => submitHandler(e)}
        className="contact-validation-active"
      >
        <div className="row">
          <div className="col col-lg-6 col-12">
            <div className="form-field">
              <input
                value={forms.name}
                type="text"
                name="name"
                onBlur={(e) => changeHandler(e)}
                onChange={(e) => changeHandler(e)}
                placeholder="Nombre y Apellido"
              />
              {validator.message("name", forms.name, "required|alpha_space")}
            </div>
          </div>
          <div className="col col-lg-6 col-12">
            <div className="form-field">
              <input
                value={forms.email}
                type="email"
                name="email"
                onBlur={(e) => changeHandler(e)}
                onChange={(e) => changeHandler(e)}
                placeholder="Tu Email"
              />
              {validator.message("email", forms.email, "required|email")}
            </div>
          </div>
          <div className="col col-lg-6 col-12">
            <div className="form-field">
              <input
                value={forms.phone}
                type="phone"
                name="phone"
                onBlur={(e) => changeHandler(e)}
                onChange={(e) => changeHandler(e)}
                placeholder="Tu teléfono"
              />
              {validator.message("phone", forms.phone, "required|phone")}
            </div>
          </div>
          <div className="col col-lg-6 col-12">
            <div className="form-field">
              <input
                value={forms.subject}
                type="text"
                name="subject"
                onBlur={(e) => changeHandler(e)}
                onChange={(e) => changeHandler(e)}
                placeholder="Asunto"
              />
            </div>
          </div>
          <div className="col col-lg-12 col-12">
            <textarea
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              value={forms.message}
              type="text"
              name="message"
              placeholder="Mensaje"
            ></textarea>
            {validator.message("message", forms.message, "required")}
          </div>
        </div>
        <div className="submit-area">
          <button 
            type="submit" 
            className="theme-btn"
            disabled={isLoading}
          >
            {isLoading ? 'Enviando...' : 'Enviar Mensaje'}
          </button>
        </div>
      </form>
    );
}

export default ContactForm;